import React, { Component } from "react";

export class Payables extends Component {
  constructor() {
    super();
    this.state = {};
  }

  render() {
    return (
      <div className="ui-g">
        <div className="ui-g-12">
          <div className="card">
            <h1>Payables</h1>
            <p>
              This page will display a list of Payables to sync to accountancy
              package generated by Purchase Order's within BPMBuild.
            </p>
          </div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Payable/Payables.js